import Episode from '@models/Episode';
import { Podcast } from '@models/Podcast';
import { Topic } from '@models/Topic';
import PodcastPage from '@pages/PodcastPage';
import API from '@services/index';
import { GetServerSideProps } from 'next';
import React from 'react';

export default function Page(props: {
  podcast: Podcast;
  topics: Topic[];
  episodes: Episode[];
}) {
  return <PodcastPage {...props} />;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const res = await API.getPodcast(context.params.podcastId as string);

  if (res.status !== 200) throw new Error('got ' + res.status);

  const errorMsg = (res.data as any).message;
  let podcastData = res.data;
  const podcast = podcastData.podcast;

  if (!podcastData.result) throw new Error(errorMsg);

  const topicsRes = await API.getTopics(podcastData.podcast.id);
  const episodesRes = await API.getEpisodes(podcastData.podcast.id);

  const topics = topicsRes.data.datas;
  const episodes = episodesRes.data.datas;

  return { props: { podcast, topics, episodes } };
};
